// Video storage backend selection.
//
// Controls whether video upload/playback uses Firebase Storage (the live,
// default path) or Cloudflare R2 (presigned URLs minted by the backend).
//
// Default is "firebase" so the live, mission-critical upload pipeline keeps
// working until R2 infra (buckets, secrets, CORS) is provisioned and the
// presign endpoints are deployed. Flip to "r2" via env once ready.
//
//   REACT_APP_VIDEO_BACKEND=r2
//
// The flag is read once at module load. Screens branch on getVideoBackend().

const RAW = (process.env.REACT_APP_VIDEO_BACKEND || "firebase").trim().toLowerCase();

const VIDEO_BACKEND = RAW === "r2" ? "r2" : "firebase";

export function getVideoBackend() {
  return VIDEO_BACKEND;
}

export function isR2Backend() {
  return VIDEO_BACKEND === "r2";
}
